import { useState } from 'react'
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger
} from '~/components/UI/shadcn/tabs'

import { cva } from 'class-variance-authority'
import { cn } from '~/lib/utils'
import { isDevelopment } from '~/utils/misc'
import HtmlBlock from '~/components/Helpers/HtmlBlock'

interface TabItem {
  id: number
  icon: { asset: { sys: { uri: string } } }
  bgColour:
    | 'ink-blue'
    | 'mid-blue'
    | 'light-blue'
    | 'light-pink'
    | 'light-purple'
    | 'light-orange'
    | 'light-aqua'
    | undefined
  header: string
  content: string
}

type IconConfig = {
  variant: 'horizontal' | 'vertical'
  tabs: TabItem[]
}

const tabOrientation = cva('bg-transparent dark:bg-transparent', {
  variants: {
    orientation: {
      horizontal: 'space-x-m w-auto h-auto',
      vertical: 'flex-col justify-start space-y-m h-auto'
    }
  },
  defaultVariants: {
    orientation: 'horizontal'
  }
})

const tabStyles = cva(
  'h-xl w-xl rounded-full p-xs hover:bg-grey-l dark:hover:bg-blue-d-80 shrink-0',
  {
    variants: {
      colour: {
        'ink-blue':
          ' data-[state=active]:bg-blue-d dark:data-[state=active]:bg-white',
        'mid-blue':
          'data-[state=active]:bg-blue-m dark:data-[state=active]:bg-blue-m',
        'light-blue':
          'data-[state=active]:bg-blue-l dark:data-[state=active]:bg-blue-l',
        'light-pink':
          'data-[state=active]:bg-pink dark:data-[state=active]:bg-pink',
        'light-aqua':
          'data-[state=active]:bg-green dark:data-[state=active]:bg-green',
        'light-purple':
          'data-[state=active]:bg-purple dark:data-[state=active]:bg-purple',
        'light-orange':
          'data-[state=active]:bg-orange dark:data-[state=active]:bg-orange'
      }
    },
    defaultVariants: {
      colour: 'light-pink'
    }
  }
)

const Icons = ({ variant, tabs }: IconConfig) => {
  // set and store active tab on click
  const [activeTab, setActiveTab] = useState<number>(0)

  const previewUrl = isDevelopment
    ? 'https://preview-websitemodern-uni-hull.cloud.contensis.com'
    : ''

  return (
    <Tabs
      defaultValue={tabs[0].header.toLowerCase()}
      className={`flex w-full items-start ${variant === 'vertical' ? 'space-x-m flex-row' : 'space-y-m flex-col'}`}
      orientation={variant}
    >
      <TabsList
        className={cn(
          'flex flex-wrap items-start justify-start',
          tabOrientation({ orientation: variant })
        )}
      >
        {Array.isArray(tabs) &&
          tabs.map(item => (
            <TabsTrigger
              key={item.id}
              value={item.header.toLowerCase()}
              onFocus={() => setActiveTab(item.id)}
              className={cn(tabStyles({ colour: item.bgColour }))}
            >
              <picture>
                <img
                  src={
                    previewUrl +
                    (activeTab === item.id
                      ? item.bgColour === 'mid-blue' ||
                        item.bgColour === 'ink-blue'
                        ? item.icon.asset.sys.uri.replace(
                            '/duotone/ink-blue/mid-blue/',
                            '/single-colour/white/'
                          )
                        : item.icon.asset.sys.uri.replace(
                            '/duotone/ink-blue/mid-blue/',
                            '/single-colour/ink-blue/'
                          )
                      : item.icon.asset.sys.uri)
                  }
                  alt={item.header}
                  className='w-8'
                />
              </picture>
              {/* <picture className='hidden dark:flex'>
                <img
                  src={
                    previewUrl +
                    (activeTab === item.id
                      ? item.bgColour === 'mid-blue'
                        ? item.icon.asset.sys.uri.replace(
                            '/duotone/ink-blue/mid-blue/',
                            '/single-colour/white/'
                          )
                        : item.icon.asset.sys.uri.replace(
                            '/duotone/ink-blue/mid-blue/',
                            '/single-colour/ink-blue/'
                          )
                      : item.icon.asset.sys.uri.replace(
                          '/duotone/ink-blue/mid-blue/',
                          '/single-colour/white/'
                        ))
                  }
                  alt={item.header}
                  className='w-m'
                />
              </picture> */}
            </TabsTrigger>
          ))}
      </TabsList>
      {Array.isArray(tabs) &&
        tabs.map(item => (
          <TabsContent
            key={item.id}
            value={item.header.toLowerCase()}
            className='w-full min-w-80'
          >
            <h3 className='mb-xs'>{item.header}</h3>
            <HtmlBlock content={item.content} />
          </TabsContent>
        ))}
    </Tabs>
  )
}

export default Icons
